import { iconForSlug } from "@/components/ui/icons/A1Icons";

// Slim per-service identity band — unique icon + one-line summary so each
// service page reads distinctly (Brand-Distinction Round 2).
export default function ServiceIdentityStrip({ service }) {
    const Icon = iconForSlug(service.slug);
    return (
        <section className="svc-identity-strip" data-testid="svc-identity-strip">
            <div className="a1-container flex items-center gap-5 relative">
                <div className="svc-identity-icon" aria-hidden="true">
                    <Icon size={40} strokeWidth={1.3} />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="svc-identity-kicker">A1 Specialty · {service.name}</p>
                    <p className="svc-identity-line">{service.hero_summary}</p>
                </div>
                <div className="svc-identity-watermark" aria-hidden="true">
                    <Icon size={150} strokeWidth={0.8} />
                </div>
            </div>
        </section>
    );
}
